<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog
      v-model="dialog"
      max-width="600"
      persistent
  >
    <v-card>
      <v-toolbar color="black" dark>
        <v-toolbar-title v-if="newItem">{{ $t(`tehtava.new_${item}`) }}</v-toolbar-title>
        <v-toolbar-title v-else>{{ $t(`tehtava.edit_${item}`) }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">

        <v-form ref="form">


          <template v-if="item === 'tehtava'">
            <v-autocomplete v-model="link.vuosi"
                            :items="$years"
                            :label="$t('year')"
                            hide-detail
                            @change="() => {this.$emit('vuosi-selected', this.link.vuosi)}"/>

            <v-autocomplete v-model="link.vastuualueId"
                            :item-text="(item) => item.nimi"
                            :items="vastuualueet"
                            :label="$tc('vastuualue.title',1)"
                            item-value="id"
                            validate-on-blur
                            @change="() => {this.$emit('vastuualue-selected', this.link.vastuualueId)}"/>

            <v-autocomplete v-model="link.tehtavaId"
                            :item-text="(item) => item.otsikko"
                            :items="linkTehtavat"
                            :label="$tc('tehtava.title',1)"
                            item-value="id"
                            validate-on-blur/>
          </template>

          <template v-if="item === 'henkilo'">
            <v-autocomplete v-model="henkiloLink.userId"
                            :item-text="(item) => item.firstname + ' ' + item.lastname"
                            :items="linkUsers"
                            :label="$tc('tehtava.henkilo',1)"
                            item-value="id"
                            validate-on-blur/>
          </template>

          <template v-if="item === 'url'">
            <v-text-field v-model="ulkopuolinenLinkki.otsikko"
                          :disabled="saving"
                          :label="$t('tehtava.url_kuvaus')"
                          :rules="[$rules.required]"
                          type="text"
                          validate-on-blur
            />
            <v-text-field v-model="ulkopuolinenLinkki.url"
                          :disabled="saving"
                          :label="$t('tehtava.url_linkki')"
                          :rules="[$rules.required]"
                          type="url"
                          validate-on-blur
            />
            <div class="text-center">
              <v-alert class="mb-0" outlined text type="info" width="100%">
                {{ $t('tehtava.url_linkki_ohje') }}
              </v-alert>

            </div>
            <!--<v-autocomplete v-model="ulkopuolinenLinkki.tyyppi"
                            :disabled="saving"
                            :items="urlTypes"
                            :label="$t('tehtava.url_type')"
                            :rules="[$rules.required]"
                            item-text="text"
                            item-value="value"
                            type="text"
                            validate-on-blur
            />-->
          </template>
        </v-form>
      </v-card-text>
      <v-divider/>
      <v-card-actions :class="$vuetify.breakpoint.xsOnly && 'flex-column-reverse'">
        <v-spacer></v-spacer>
        <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
            :large="$vuetify.breakpoint.xsOnly"
            :text="$vuetify.breakpoint.smAndUp"
            @click="cancel"
        >
          {{ $t('cancel') }}
        </v-btn>
        <v-btn
            :block="$vuetify.breakpoint.xsOnly"
            :class="$vuetify.breakpoint.xsOnly ? 'ma-1' : ''"
            :large="$vuetify.breakpoint.xsOnly"
            :loading="saving"
            color="primary"
            @click="save"
        >
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "../../apicollection";

export default {
  props: {
    tehtavaId: Number,
    valintaId: Number,
    tehtava: Object,
    linkUsers: Array,
    linkTehtavat: Array
  },
  name: 'AddLinkkiDialog',
  data() {
    return {
      saving: false,
      loading: false,
      newItem: false,
      item: null,
      dialog: false,
      link: {
        vuosi: null,
        vastuualueId: null,
        tehtavaId: null,
        _tehtavat: [],
      },
      vastuualueet: [],
      linkit: [],
      henkiloLink: {
        userId: null,
      },
      henkiloLinkit: [],
      ulkopuolinenLinkki: {
        otsikko: '',
        url: '',
        tyyppi: 'TIEDOSTO',
      },
      tehtavaCopy: null,
      urlTypes: [
        {
          text: this.$t('tehtava.tiedosto'),
          value: 'TIEDOSTO'
        },
        {
          text: this.$t('tehtava.planner'),
          value: 'PLANNER'
        }
      ]
    };
  },
  methods: {
    open(item, newItem) {
      this.item = item;
      this.newItem = newItem;
      this.link.vuosi = this.tehtava.vuosi;
      this.getVastuualueet();
      this.dialog = true;
    },
    async save() {
      if (this.item === 'tehtava') {
        await this.addTehtavaLinkki();
      } else if (this.item === 'henkilo') {
        await this.addTehtavaHenkiloLinkki();
      } else if (this.item === 'url') {
        await this.addUrlLinkki();
      }
    },

    async addUrlLinkki() {
      if (!this.tehtavaId) return this.$showErrorNotification(this.$t('errors.error_saving_url'))
      if (!this.$refs.form.validate()) return false;
      this.$emit('savingURLLink', true)
      try {
        await api.addUlkopuolinenLinkki(this.tehtavaId, this.ulkopuolinenLinkki);
        this.$showSuccessNotification(this.$t('tehtava.url_linkki_saved'), false)
        this.$emit('reload', this.item);
        this.cancel();
      } catch (e) {
        console.error(e)
        this.$showErrorNotification(this.$t('errors.error_saving_url'))
      } finally {
        this.$emit('savingURLLink', false)
      }
    },
    async addTehtavaHenkiloLinkki() {
      if (!this.tehtava.id || !this.henkiloLink.userId) return this.$showErrorNotification(this.$t('errors.error_saving_tehtava_henkilo_linkki'))
      if (!this.$refs.form.validate()) return false;
      this.savingHenkiloLink = true;
      try {
        await api.addTehtavaHenkiloLinkki(this.tehtava.id, this.henkiloLink.userId);

        this.$showSuccessNotification(this.$t('tehtava.henkilo_linkki_saved'), false)
        this.$emit('reload', this.item);
        this.henkiloLink.userId = null;
        this.cancel();
      } catch (e) {
        console.error(e)
        this.$showErrorNotification(this.$t('errors.error_saving_tehtava_henkilo_linkki'))
      } finally {
        this.savingHenkiloLink = false;
      }
    },
    async addTehtavaLinkki() {
      if (!this.tehtava.id || !this.link.tehtavaId) return this.$showErrorNotification(this.$t('errors.error_saving_tehtava_linkki'))
      if (!this.$refs.form.validate()) return false;
      this.savingLink = true;
      try {
        await api.addTehtavaLinkki(this.tehtava.id, this.link.tehtavaId);

        this.$showSuccessNotification(this.$t('tehtava.linkki_saved'), false)
        this.$emit('reload', this.item);
        this.link.tehtavaId = null;
        this.cancel();
      } catch (e) {
        console.error(e)
        this.$showErrorNotification(this.$t('errors.error_saving_tehtava_linkki'))
      } finally {
        this.savingLink = false;
      }
    },
    async getVastuualueet() {
      const vastuualueet = await api.getVastuualueet();
      this.vastuualueet = vastuualueet;
    },
    cancel() {
      this.dialog = false;
      this.newItem = false,
          this.item = null;
      this.ulkopuolinenLinkki = {otsikko: '', url: '', tyyppi: 'TIEDOSTO'};
    }
  },
};
</script>

<style scoped></style>
